<div class="loader-holder">
    <img src="/assets/images/Spinner.svg" class="loading-spinner" alt="placeholder"
        id="placeholder" />
    <h5>Loading...</h5>
</div>